// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../Typography/Body", "../Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../Typography/Body"), require("../Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Body, global.Icon);
    global.Base = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Body, _Icon) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.BaseButton = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var PX_CLASS_NAMES = {
    sm: 'cop-px-2',
    base: 'cop-px-3'
  };
  var HEIGHT_CLASS_NAMES = {
    sm: 'cop-h-7',
    base: 'cop-h-8'
  };
  var ICON_PR_CLASS_NAMES = {
    sm: 'cop-pr-2',
    base: 'cop-pr-2'
  };
  var BaseButton = _exports.BaseButton = function BaseButton(_ref) {
    var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disclosure = _ref.disclosure,
      disclosure = _ref$disclosure === void 0 ? false : _ref$disclosure,
      label = _ref.label,
      onClick = _ref.onClick,
      prefixIcon = _ref.prefixIcon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'base' : _ref$size;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: ['cop-flex', 'hover:cop-opacity-80', 'cop-items-center', 'cop-rounded', 'cop-transition-opacity', 'cop-items-center', PX_CLASS_NAMES[size], HEIGHT_CLASS_NAMES[size], className].join(' '),
      onClick: onClick
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, prefixIcon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: prefixIcon
      // TODO(@foley): It'd be nice to get rid of these `!important` modifiers, but the figma
      // script imports inline stroke and fill attributes. We should update the script to
      // remove these attributes.
      ,
      className: "".concat(ICON_PR_CLASS_NAMES[size], " cop-h-3 cop-w-3 [&>path]:!cop-fill-current [&>path]:!cop-stroke-current")
    }), /*#__PURE__*/_react["default"].createElement(_Body.Body, {
      variant: size
    }, label), disclosure && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-pl-2"
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "ChevronDown",
      className: "cop-h-3 cop-w-3"
    }))));
  };
});
